import React, { createContext, useContext, useState, useEffect } from 'react';

const LanguageContext = createContext();

export const translations = {
  en: {
    // Navigation
    nav: {
      home: "Home",
      courses: "Courses",
      schedule: "Schedule",
      services: "Services",
      gallery: "Gallery",
      contact: "Contact",
      admin: "Admin"
    },
    // Hero
    hero: {
      title: "Nina Beauty Academy",
      subtitle: "Professional Nail & Lash Training in Riyadh",
      viewCourses: "View Courses",
      bookTraining: "Book Training"
    },
    // About
    about: {
      title: "Meet Nina Ceban",
      subtitle: "International Trainer",
      description: "With over 8 years of professional experience and having trained more than 100 students, Nina Ceban is a recognized expert in manicure, pedicure, gel nail extensions, and lash extensions. Her academy offers world-class training that combines Russian techniques with modern innovations.",
      experience: "8+ Years Experience",
      students: "100+ Trained Students",
      certified: "Certified International Trainer"
    },
    // Services
    services: {
      title: "Our Services",
      subtitle: "Premium beauty services by certified professionals",
      bookNow: "Book Now",
      duration: "Duration",
      price: "Price"
    },
    // Courses
    courses: {
      title: "Professional Training Courses",
      subtitle: "Start your career in the beauty industry",
      curriculum: "Course Curriculum",
      groupPrice: "Group Training",
      individualPrice: "Individual Training",
      certificate: "Certificate included upon completion",
      enrollNow: "Enroll Now",
      sar: "SAR"
    },
    // Schedule
    schedule: {
      title: "Training Schedule",
      subtitle: "Upcoming course dates",
      spotsAvailable: "spots available",
      reserveSpot: "Reserve Spot",
      noSchedule: "No upcoming training sessions at the moment. Check back soon!"
    },
    // Gallery
    gallery: {
      title: "Our Gallery",
      subtitle: "See our work and training sessions"
    },
    // Testimonials
    testimonials: {
      title: "Student Testimonials",
      subtitle: "What our graduates say"
    },
    // Contact
    contact: {
      title: "Book Your Session",
      subtitle: "Get in touch with us",
      form: {
        name: "Full Name",
        phone: "Phone Number",
        email: "Email (Optional)",
        serviceType: "Service Type",
        course: "Training Course",
        service: "Beauty Service",
        selectOption: "Select an option",
        preferredDate: "Preferred Date",
        message: "Message (Optional)",
        submit: "Submit Booking",
        success: "Booking submitted successfully! We'll contact you soon.",
        error: "Failed to submit booking. Please try again."
      },
      whatsapp: "Contact on WhatsApp",
      instagram: "Follow on Instagram",
      location: "Location",
      riyadh: "Riyadh, Saudi Arabia"
    },
    // Admin
    admin: {
      title: "Admin Panel",
      login: "Login",
      logout: "Logout",
      username: "Username",
      password: "Password",
      loginBtn: "Login",
      addSchedule: "Add Training Date",
      editSchedule: "Edit Schedule",
      deleteSchedule: "Delete",
      save: "Save",
      cancel: "Cancel",
      courseTitleEn: "Course Title (English)",
      courseTitleAr: "Course Title (Arabic)",
      startDate: "Start Date",
      endDate: "End Date",
      spots: "Available Spots",
      active: "Active",
      bookings: "Bookings",
      manageSchedule: "Manage Schedule"
    },
    // Footer
    footer: {
      rights: "All rights reserved",
      followUs: "Follow Us"
    },
    // CTA
    cta: {
      title: "Ready to Start Your Journey?",
      subtitle: "Join Nina Beauty Academy and become a certified professional",
      button: "Book Training Now"
    }
  },
  ar: {
    // Navigation
    nav: {
      home: "الرئيسية",
      courses: "الدورات",
      schedule: "الجدول",
      services: "الخدمات",
      gallery: "المعرض",
      contact: "اتصل بنا",
      admin: "الإدارة"
    },
    // Hero
    hero: {
      title: "أكاديمية نينا للتجميل",
      subtitle: "تدريب احترافي على الأظافر والرموش في الرياض",
      viewCourses: "عرض الدورات",
      bookTraining: "احجز تدريبك"
    },
    // About
    about: {
      title: "تعرفي على نينا سيبان",
      subtitle: "مدربة دولية",
      description: "مع أكثر من 8 سنوات من الخبرة المهنية وتدريب أكثر من 100 طالبة، تُعد نينا سيبان خبيرة معترف بها في المانيكير والباديكير وتركيب الأظافر الجل وتركيب الرموش. تقدم أكاديميتها تدريباً عالمي المستوى يجمع بين التقنيات الروسية والابتكارات الحديثة.",
      experience: "+8 سنوات خبرة",
      students: "+100 طالبة مدربة",
      certified: "مدربة دولية معتمدة"
    },
    // Services
    services: {
      title: "خدماتنا",
      subtitle: "خدمات تجميل متميزة من محترفين معتمدين",
      bookNow: "احجزي الآن",
      duration: "المدة",
      price: "السعر"
    },
    // Courses
    courses: {
      title: "دورات التدريب الاحترافية",
      subtitle: "ابدئي مسيرتك المهنية في صناعة التجميل",
      curriculum: "منهج الدورة",
      groupPrice: "تدريب جماعي",
      individualPrice: "تدريب فردي",
      certificate: "شهادة معتمدة عند إتمام الدورة",
      enrollNow: "سجلي الآن",
      sar: "ر.س"
    },
    // Schedule
    schedule: {
      title: "جدول التدريب",
      subtitle: "مواعيد الدورات القادمة",
      spotsAvailable: "مقاعد متاحة",
      reserveSpot: "احجزي مقعدك",
      noSchedule: "لا توجد جلسات تدريبية قادمة حالياً. تحققي مرة أخرى قريباً!"
    },
    // Gallery
    gallery: {
      title: "معرض الصور",
      subtitle: "شاهدي أعمالنا وجلسات التدريب"
    },
    // Testimonials
    testimonials: {
      title: "آراء الطالبات",
      subtitle: "ماذا تقول خريجاتنا"
    },
    // Contact
    contact: {
      title: "احجزي موعدك",
      subtitle: "تواصلي معنا",
      form: {
        name: "الاسم الكامل",
        phone: "رقم الهاتف",
        email: "البريد الإلكتروني (اختياري)",
        serviceType: "نوع الخدمة",
        course: "دورة تدريبية",
        service: "خدمة تجميل",
        selectOption: "اختاري خيار",
        preferredDate: "التاريخ المفضل",
        message: "رسالة (اختياري)",
        submit: "إرسال الحجز",
        success: "تم إرسال الحجز بنجاح! سنتواصل معك قريباً.",
        error: "فشل إرسال الحجز. يرجى المحاولة مرة أخرى."
      },
      whatsapp: "تواصلي عبر واتساب",
      instagram: "تابعينا على إنستغرام",
      location: "الموقع",
      riyadh: "الرياض، المملكة العربية السعودية"
    },
    // Admin
    admin: {
      title: "لوحة الإدارة",
      login: "تسجيل الدخول",
      logout: "تسجيل الخروج",
      username: "اسم المستخدم",
      password: "كلمة المرور",
      loginBtn: "دخول",
      addSchedule: "إضافة موعد تدريب",
      editSchedule: "تعديل الجدول",
      deleteSchedule: "حذف",
      save: "حفظ",
      cancel: "إلغاء",
      courseTitleEn: "عنوان الدورة (إنجليزي)",
      courseTitleAr: "عنوان الدورة (عربي)",
      startDate: "تاريخ البدء",
      endDate: "تاريخ الانتهاء",
      spots: "المقاعد المتاحة",
      active: "نشط",
      bookings: "الحجوزات",
      manageSchedule: "إدارة الجدول"
    },
    // Footer
    footer: {
      rights: "جميع الحقوق محفوظة",
      followUs: "تابعينا"
    },
    // CTA
    cta: {
      title: "هل أنتِ مستعدة لبدء رحلتك؟",
      subtitle: "انضمي إلى أكاديمية نينا للتجميل وكوني محترفة معتمدة",
      button: "احجزي تدريبك الآن"
    }
  }
};

export const LanguageProvider = ({ children }) => {
  const [language, setLanguage] = useState(() => {
    const saved = localStorage.getItem('nina-academy-lang');
    return saved || 'en';
  });

  useEffect(() => {
    localStorage.setItem('nina-academy-lang', language);
    document.documentElement.dir = language === 'ar' ? 'rtl' : 'ltr';
    document.documentElement.lang = language;
  }, [language]);

  const toggleLanguage = () => {
    setLanguage(prev => prev === 'en' ? 'ar' : 'en');
  };

  const t = translations[language];

  return (
    <LanguageContext.Provider value={{ language, toggleLanguage, t, isRTL: language === 'ar' }}>
      {children}
    </LanguageContext.Provider>
  );
};

export const useLanguage = () => {
  const context = useContext(LanguageContext);
  if (!context) {
    throw new Error('useLanguage must be used within a LanguageProvider');
  }
  return context;
};
